
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardFooter, 
  CardHeader, 
  CardTitle 
} from '@/components/ui/card';

interface ResultsCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  delay?: number;
}

const ResultsCard: React.FC<ResultsCardProps> = ({
  title,
  description,
  children,
  className,
  delay = 0,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.5, 
        delay: delay,
        ease: [0.43, 0.13, 0.23, 0.96] 
      }}
    >
      <Card className={cn("overflow-hidden", className)}>
        <CardHeader className="bg-gradient-to-r from-morgenBlue to-morgenViolet text-white">
          <CardTitle>{title}</CardTitle>
          {description && <CardDescription className="text-white/80">{description}</CardDescription>}
        </CardHeader>
        <CardContent className="pt-6">
          {children}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ResultsCard;
